import * as LabelPrimitive from "@radix-ui/react-label";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import styled from "styled-components";

export const Layout = styled.div`
  display: flex;
  align-items: center;
`;

export const Label = styled(LabelPrimitive.Root)<{ disabled?: boolean }>`
  font-family:
    Open Sans,
    sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  padding-right: 10px;
  cursor: pointer;
  ${props =>
    props.disabled
      ? "color:var(--mode-vector-neutral-default)"
      : "color:var(--mode-vector-neutral-stronger)"};
`;

export const Root = styled(SwitchPrimitive.Root)`
  all: unset;
  cursor: pointer;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  width: 32px;
  height: 18px;
  box-sizing: border-box;
  border-radius: 20px;
  padding: 2px;
  position: relative;
  background-color: var(--mode-bg-neutral-weak);

  &[data-state="checked"] {
    background-color: var(--mode-bg-primary-default);

    &:active {
      background-color: var(--mode-bg-primary-strong);
    }
  }

  &:active {
    background-color: var(--mode-bg-primary-weaker);
  }

  &:focus {
    padding: 1px;
    border: 1px solid var(--mode-border-primary-strong);
    box-shadow:
      0px 0px 2px var(--mode-shadow-button-focus),
      inset 0 0 2px var(--mode-shadow-button-focus);
  }
`;

export const Thumb = styled(SwitchPrimitive.Thumb)`
  display: block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: var(--mode-bg-neutral-weakest);
  box-shadow: var(--mode-bs-small);
  &[data-disabled] {
    background-color: var(--mode-bg-neutral-weakest);
  }

  &[data-state="checked"] {
    transform: translateX(14px);

    &[data-disabled] {
      background-color: var(--mode-bg-primary-weakest);
    }
  }
`;
